import { AxiosResponse } from "axios";
import { ensureArray } from "types";

import { get, IHttpRequestConfig, put } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose, IURLSearchParams } from "@/core/url";
import {
  IPageableTask,
  IPartialPageableTask,
  ITaskCount,
  ITaskOriginService,
  pageableTaskType,
  TaskAction,
  taskCountType,
  taskOriginServiceType,
} from "@/data/tasks/types";

const API = {
  list: "/api/tasks",
  action: "/api/tasks/{taskId}/complete",
  count: "/api/tasks/count",
  originServices: "/api/tasks/origin-services",
};

export interface IFetchTasksListParams extends IURLSearchParams {
  companyId?: number;
  withAssignee?: boolean;
}

export const fetchTasks = (
  params: IFetchTasksListParams = {},
  options: IHttpRequestConfig = {},
): Promise<IPageableTask> => {
  const { companyId, ...searchParams } = params;
  const url = compose(API.list, {}, searchParams);

  return get<IPartialPageableTask>(url, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(pageableTaskType);
};

export interface IPutTaskActionParams {
  companyId?: number;
  taskId: number;
}

export const putTaskAction = (
  params: IPutTaskActionParams,
  data: TaskAction,
  options: IHttpRequestConfig = {},
): Promise<AxiosResponse<void>> => {
  const { taskId, companyId } = params;
  const url = compose(API.action, { taskId });

  return put(url, data, applyHeaders({ companyId }, options));
};

export const fetchTasksCount = (
  params: IFetchTasksListParams = {},
  options: IHttpRequestConfig = {},
): Promise<ITaskCount> => {
  const { companyId, ...searchParams } = params;
  const url = compose(API.count, {}, searchParams);

  return get<ITaskCount>(url, applyHeaders({ companyId }, options)).then(extractDataFromResponse).then(taskCountType);
};

export interface IFetchTasksOriginServicesParams {
  companyId?: number;
}

export const fetchTasksOriginServices = (
  params: IFetchTasksOriginServicesParams = {},
  options: IHttpRequestConfig = {},
): Promise<ITaskOriginService[]> => {
  const { companyId, ...searchParams } = params;
  const url = compose(API.originServices, {}, searchParams);

  return get<ITaskOriginService[]>(url, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(ensureArray(taskOriginServiceType));
};
